export type QBankCode = "sdle" | "smle";

export interface QBankSpecialtyConfig {
  slug: string;
  name: string;
  section: string;
  count?: number;
}

export interface QBankConfig {
  code: QBankCode;
  name: string;
  short_name: string;
  beta: boolean;
  retrieval_domain: "dentistry" | "medicine";
  description: string;
  accent_color: string;
  option_count: number | null;
  default_specialty: string;
  specialties: QBankSpecialtyConfig[];
  sections: string[];
}

export const isQBankCode = (value: string | undefined): value is QBankCode =>
  value === "sdle" || value === "smle";

export const qbankLabel = (bank: QBankCode) =>
  bank === "smle" ? "SMLE QBank" : "SDLE QBank";

export const qbankDomain = (bank: QBankCode) =>
  bank === "smle" ? "medicine" : "dentistry";

export const withBank = (url: string, bank: QBankCode) => {
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}bank=${bank}`;
};
